var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "modal" } }, [
    _c("div", { staticClass: "modal-mask" }, [
      _c("div", { staticClass: "modal-wrapper" }, [
        _c(
          "div",
          {
            staticClass: "modal-container modal-container-40",
            on: { mousedown: _vm.dontClose },
          },
          [
            _c(
              "div",
              {
                staticClass: "modal-body m-0",
                staticStyle: { "overflow-y": "auto" },
                style: { maxHeight: _vm.getMaxHeightClient() + "px" },
              },
              [
                _c(
                  "div",
                  {
                    staticStyle: { margin: "0px 20px 0px 20px" },
                    attrs: { slot: "formcontent" },
                    slot: "formcontent",
                  },
                  [
                    _c(
                      "b-row",
                      [
                        _c("b-col", { staticStyle: { "text-align": "end" } }, [
                          _c("i", {
                            staticClass: "fa fa-times close-button",
                            staticStyle: { "font-size": "20px" },
                            on: { click: _vm.handleMouseDown },
                          }),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      { staticClass: "panel-heading" },
                      [
                        _c(
                          "b-col",
                          {
                            staticClass: "formTitleBlock",
                            attrs: { cols: "12" },
                          },
                          [
                            _c(
                              "h4",
                              {
                                staticClass: "content-block labelAccordionForm",
                              },
                              [
                                _c("i", {
                                  staticClass: "fa-light fa-file-code mr-2",
                                  staticStyle: { "font-size": "20px" },
                                }),
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.isAdmin
                                        ? _vm.$t("bank_accounts.type_bk_dbtr")
                                        : _vm.$t("bank_accounts.slct_bk_dbtr")
                                    ) +
                                    "\n                "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { attrs: { sm: "10", md: "8", lg: "10", xl: "8" } },
                          [
                            !_vm.isAdmin
                              ? _c("select-bank-account", {
                                  attrs: {
                                    labelClass: "createInvoiceBand mb-0",
                                    inputClass:
                                      "d-flex align-items-center icon-input bank-account-icon",
                                    inputIcon:
                                      "fa-solid fa-building-columns text-info",
                                  },
                                  model: {
                                    value: _vm.bankAccount,
                                    callback: function ($$v) {
                                      _vm.bankAccount = $$v
                                    },
                                    expression: "bankAccount",
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c("form-write-group-label-input", {
                              attrs: {
                                isMandatory: "",
                                labelClass: "mb-0",
                                inputLabel: _vm.$t(
                                  "bank_accounts.bank_account_singular"
                                ),
                                specificErrorIndicator: _vm.bankAccountError,
                                specificMessage: _vm.bankAccountErrorMessage,
                              },
                              model: {
                                value: _vm.bankAccount,
                                callback: function ($$v) {
                                  _vm.bankAccount = $$v
                                },
                                expression: "bankAccount",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "modal-footer" },
              [
                _c(
                  "b-col",
                  {
                    staticClass: "p-0 m-0",
                    attrs: { cols: "6", sm: "4", md: "3", lg: "3", xl: "3" },
                  },
                  [
                    _c(
                      "b-button",
                      {
                        attrs: {
                          variant: "primary",
                          disabled: !_vm.bankAccount,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.selectBankAccount()
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("common.pay")) +
                            "\n            "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }